import moment from "moment";

const resolveOutcome = (row) => {
  const status = String(row?.status || row?.outcome || "").toLowerCase().trim();
  if (status === "success" || status === "sent" || Number(row?.is_sent) === 1) {
    return "success";
  }
  if (status === "failed") {
    return "failed";
  }
  return "pending";
};

/**
 * Build analytics payload from log rows when /logs/analytics API fails.
 */
export function computeCampaignAnalyticsFromLogs(rows, period = "30") {
  const list = Array.isArray(rows) ? rows : [];
  const allTime = period === "all" || period === "0" || period === 0;
  const chartDays = allTime ? 30 : Math.min(90, Math.max(7, parseInt(period, 10) || 30));
  const chartSince = moment().subtract(chartDays - 1, "days").startOf("day");

  const counts = { success: 0, failed: 0, pending: 0 };
  const dailyMap = {};

  list.forEach((row) => {
    const outcome = resolveOutcome(row);
    counts[outcome] += 1;

    const created = row.created_at ? moment(row.created_at) : null;
    if (!created?.isValid() || created.isBefore(chartSince)) {
      return;
    }

    const day = created.format("YYYY-MM-DD");
    if (!dailyMap[day]) {
      dailyMap[day] = { success: 0, failed: 0, pending: 0 };
    }
    dailyMap[day][outcome] += 1;
  });

  const total = counts.success + counts.failed + counts.pending;
  const labels = [];
  const dates = [];
  const successSeries = [];
  const failedSeries = [];
  const pendingSeries = [];

  for (let i = 0; i < chartDays; i++) {
    const day = chartSince.clone().add(i, "days").format("YYYY-MM-DD");
    const dayCounts = dailyMap[day] || { success: 0, failed: 0, pending: 0 };
    labels.push(moment(day).format("D MMM"));
    dates.push(day);
    successSeries.push(dayCounts.success);
    failedSeries.push(dayCounts.failed);
    pendingSeries.push(dayCounts.pending);
  }

  return {
    days: allTime ? 0 : chartDays,
    all_time: allTime,
    custom: false,
    period_label: allTime ? "All time" : `Last ${chartDays} days`,
    source: "client_fallback",
    summary: {
      total,
      success: counts.success,
      failed: counts.failed,
      pending: counts.pending,
      success_rate: total > 0 ? Math.round((counts.success / total) * 1000) / 10 : 0,
    },
    by_status: [
      { status: "success", count: counts.success },
      { status: "failed", count: counts.failed },
      { status: "pending", count: counts.pending },
    ],
    activity_chart: {
      labels,
      dates,
      success: successSeries,
      failed: failedSeries,
      pending: pendingSeries,
    },
  };
}
